import haroldPic from "@/public/images/artists/harold.png";
import { Artist } from "@/types/types";

export const harold = {
  id: "166",
  name: "Harold",
  image: haroldPic,
  description: `Harold's voice is weathered and rough-edged, with a subtle growl that makes his singing feel intense and emotive. It ranges from a deep, smoky whisper that lends a sultry, haunting vibe to softer songs, to a powerful, gritty belt that bursts with raw emotion in rock and blues choruses.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fharold-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock", "Gritty"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 69,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
